"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Precision = exports.SameOrBefore = exports.SameOrAfter = exports.SameAs = exports.Before = exports.After = exports.Length = exports.ProperIncludedIn = exports.ProperIncludes = exports.IncludedIn = exports.Includes = exports.Contains = exports.In = exports.Indexer = exports.Intersect = exports.Except = exports.Union = exports.NotEqual = exports.Equivalent = exports.Equal = void 0;
/* eslint-disable @typescript-eslint/ban-ts-comment */
var expression_1 = require("./expression");
var logic_1 = require("../datatypes/logic");
var datetime_1 = require("../datatypes/datetime");
var util_1 = require("../util/util");
var comparison_1 = require("../util/comparison");
var DT = __importStar(require("./datetime"));
var LIST = __importStar(require("./list"));
var IVL = __importStar(require("./interval"));
var Equal = /** @class */ (function (_super) {
    __extends(Equal, _super);
    function Equal(json) {
        return _super.call(this, json) || this;
    }
    Equal.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _a.sent();
                        if (args[0] == null || args[1] == null) {
                            return [2 /*return*/, null];
                        }
                        // @ts-ignore
                        return [2 /*return*/, comparison_1.equals.apply(void 0, args)];
                }
            });
        });
    };
    return Equal;
}(expression_1.Expression));
exports.Equal = Equal;
var Equivalent = /** @class */ (function (_super) {
    __extends(Equivalent, _super);
    function Equivalent(json) {
        return _super.call(this, json) || this;
    }
    Equivalent.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, a, b;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), a = _a[0], b = _a[1];
                        if (a == null && b == null) {
                            return [2 /*return*/, true];
                        }
                        else if (a == null || b == null) {
                            return [2 /*return*/, false];
                        }
                        else {
                            return [2 /*return*/, (0, comparison_1.equivalent)(a, b)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Equivalent;
}(expression_1.Expression));
exports.Equivalent = Equivalent;
var NotEqual = /** @class */ (function (_super) {
    __extends(NotEqual, _super);
    function NotEqual(json) {
        return _super.call(this, json) || this;
    }
    NotEqual.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var args, _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        args = _f.sent();
                        if (args[0] == null || args[1] == null) {
                            return [2 /*return*/, null];
                        }
                        _b = (_a = logic_1.ThreeValuedLogic).not;
                        _d = (_c = comparison_1.equals).apply;
                        _e = [void 0];
                        return [4 /*yield*/, this.execArgs(ctx)];
                    case 2: 
                    // @ts-ignore
                    return [2 /*return*/, _b.apply(_a, [_d.apply(_c, _e.concat([(_f.sent())]))])];
                }
            });
        });
    };
    return NotEqual;
}(expression_1.Expression));
exports.NotEqual = NotEqual;
var Union = /** @class */ (function (_super) {
    __extends(Union, _super);
    function Union(json) {
        return _super.call(this, json) || this;
    }
    Union.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, a, b, notNull, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), a = _a[0], b = _a[1];
                        if (a == null && b == null) {
                            return [2 /*return*/, this.listTypeArgs() ? [] : null];
                        }
                        if (a == null || b == null) {
                            notNull = a || b;
                            if ((0, util_1.typeIsArray)(notNull)) {
                                return [2 /*return*/, notNull];
                            }
                            else {
                                return [2 /*return*/, null];
                            }
                        }
                        lib = (0, util_1.typeIsArray)(a) ? LIST : IVL;
                        return [2 /*return*/, lib.doUnion(a, b)];
                }
            });
        });
    };
    Union.prototype.listTypeArgs = function () {
        var _a;
        return (_a = this.args) === null || _a === void 0 ? void 0 : _a.some(function (arg) {
            return arg.asTypeSpecifier != null && arg.asTypeSpecifier.type === 'ListTypeSpecifier';
        });
    };
    return Union;
}(expression_1.Expression));
exports.Union = Union;
var Except = /** @class */ (function (_super) {
    __extends(Except, _super);
    function Except(json) {
        return _super.call(this, json) || this;
    }
    Except.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, a, b, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), a = _a[0], b = _a[1];
                        if (a == null) {
                            return [2 /*return*/, null];
                        }
                        if (b == null) {
                            return [2 /*return*/, (0, util_1.typeIsArray)(a) ? a : null];
                        }
                        lib = (0, util_1.typeIsArray)(a) ? LIST : IVL;
                        return [2 /*return*/, lib.doExcept(a, b)];
                }
            });
        });
    };
    return Except;
}(expression_1.Expression));
exports.Except = Except;
var Intersect = /** @class */ (function (_super) {
    __extends(Intersect, _super);
    function Intersect(json) {
        return _super.call(this, json) || this;
    }
    Intersect.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, a, b, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), a = _a[0], b = _a[1];
                        if (a == null || b == null) {
                            return [2 /*return*/, null];
                        }
                        lib = (0, util_1.typeIsArray)(a) ? LIST : IVL;
                        return [2 /*return*/, lib.doIntersect(a, b)];
                }
            });
        });
    };
    return Intersect;
}(expression_1.Expression));
exports.Intersect = Intersect;
var Indexer = /** @class */ (function (_super) {
    __extends(Indexer, _super);
    function Indexer(json) {
        return _super.call(this, json) || this;
    }
    Indexer.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, operand, index;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), operand = _a[0], index = _a[1];
                        if (operand == null || index == null) {
                            return [2 /*return*/, null];
                        }
                        if (index < 0 || index >= operand.length) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, operand[index]];
                }
            });
        });
    };
    return Indexer;
}(expression_1.Expression));
exports.Indexer = Indexer;
var In = /** @class */ (function (_super) {
    __extends(In, _super);
    function In(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    In.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, item, container, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), item = _a[0], container = _a[1];
                        if (item == null) {
                            return [2 /*return*/, null];
                        }
                        if (container == null) {
                            return [2 /*return*/, false];
                        }
                        lib = (0, util_1.typeIsArray)(container) ? LIST : IVL;
                        return [2 /*return*/, lib.doContains(container, item, this.precision)];
                }
            });
        });
    };
    return In;
}(expression_1.Expression));
exports.In = In;
var Contains = /** @class */ (function (_super) {
    __extends(Contains, _super);
    function Contains(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    Contains.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, container, item, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), container = _a[0], item = _a[1];
                        if (container == null) {
                            return [2 /*return*/, false];
                        }
                        if (item == null) {
                            return [2 /*return*/, null];
                        }
                        lib = (0, util_1.typeIsArray)(container) ? LIST : IVL;
                        return [2 /*return*/, lib.doContains(container, item, this.precision)];
                }
            });
        });
    };
    return Contains;
}(expression_1.Expression));
exports.Contains = Contains;
var Includes = /** @class */ (function (_super) {
    __extends(Includes, _super);
    function Includes(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    Includes.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, container, contained, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), container = _a[0], contained = _a[1];
                        if (container == null || contained == null) {
                            return [2 /*return*/, null];
                        }
                        lib = (0, util_1.typeIsArray)(container) ? LIST : IVL;
                        return [2 /*return*/, lib.doIncludes(container, contained, this.precision)];
                }
            });
        });
    };
    return Includes;
}(expression_1.Expression));
exports.Includes = Includes;
var IncludedIn = /** @class */ (function (_super) {
    __extends(IncludedIn, _super);
    function IncludedIn(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    IncludedIn.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, contained, container, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), contained = _a[0], container = _a[1];
                        if (container == null || contained == null) {
                            return [2 /*return*/, null];
                        }
                        lib = (0, util_1.typeIsArray)(container) ? LIST : IVL;
                        return [2 /*return*/, lib.doIncludes(container, contained, this.precision)];
                }
            });
        });
    };
    return IncludedIn;
}(expression_1.Expression));
exports.IncludedIn = IncludedIn;
var ProperIncludes = /** @class */ (function (_super) {
    __extends(ProperIncludes, _super);
    function ProperIncludes(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    ProperIncludes.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, container, contained, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), container = _a[0], contained = _a[1];
                        if (container == null || contained == null) {
                            return [2 /*return*/, null];
                        }
                        lib = (0, util_1.typeIsArray)(container) ? LIST : IVL;
                        return [2 /*return*/, lib.doProperIncludes(container, contained, this.precision)];
                }
            });
        });
    };
    return ProperIncludes;
}(expression_1.Expression));
exports.ProperIncludes = ProperIncludes;
var ProperIncludedIn = /** @class */ (function (_super) {
    __extends(ProperIncludedIn, _super);
    function ProperIncludedIn(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    ProperIncludedIn.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, contained, container, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), contained = _a[0], container = _a[1];
                        if (container == null || contained == null) {
                            return [2 /*return*/, null];
                        }
                        lib = (0, util_1.typeIsArray)(container) ? LIST : IVL;
                        return [2 /*return*/, lib.doProperIncludes(container, contained, this.precision)];
                }
            });
        });
    };
    return ProperIncludedIn;
}(expression_1.Expression));
exports.ProperIncludedIn = ProperIncludedIn;
var Length = /** @class */ (function (_super) {
    __extends(Length, _super);
    function Length(json) {
        return _super.call(this, json) || this;
    }
    Length.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg != null) {
                            return [2 /*return*/, arg.length];
                        }
                        else if (this.arg.asTypeSpecifier.type === 'ListTypeSpecifier') {
                            return [2 /*return*/, 0];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return Length;
}(expression_1.Expression));
exports.Length = Length;
var After = /** @class */ (function (_super) {
    __extends(After, _super);
    function After(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    After.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, a, b, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), a = _a[0], b = _a[1];
                        if (a == null || b == null) {
                            return [2 /*return*/, null];
                        }
                        lib = a instanceof datetime_1.DateTime ? DT : IVL;
                        return [2 /*return*/, lib.doAfter(a, b, this.precision)];
                }
            });
        });
    };
    return After;
}(expression_1.Expression));
exports.After = After;
var Before = /** @class */ (function (_super) {
    __extends(Before, _super);
    function Before(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision != null ? json.precision.toLowerCase() : undefined;
        return _this;
    }
    Before.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, a, b, lib;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), a = _a[0], b = _a[1];
                        if (a == null || b == null) {
                            return [2 /*return*/, null];
                        }
                        lib = a instanceof datetime_1.DateTime ? DT : IVL;
                        return [2 /*return*/, lib.doBefore(a, b, this.precision)];
                }
            });
        });
    };
    return Before;
}(expression_1.Expression));
exports.Before = Before;
var SameAs = /** @class */ (function (_super) {
    __extends(SameAs, _super);
    function SameAs(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    SameAs.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, a, b;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), a = _a[0], b = _a[1];
                        if (a != null && b != null) {
                            return [2 /*return*/, a.sameAs(b, this.precision != null ? this.precision.toLowerCase() : undefined)];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return SameAs;
}(expression_1.Expression));
exports.SameAs = SameAs;
var SameOrAfter = /** @class */ (function (_super) {
    __extends(SameOrAfter, _super);
    function SameOrAfter(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    SameOrAfter.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, d1, d2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), d1 = _a[0], d2 = _a[1];
                        if (d1 != null && d2 != null) {
                            return [2 /*return*/, d1.sameOrAfter(d2, this.precision != null ? this.precision.toLowerCase() : undefined)];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return SameOrAfter;
}(expression_1.Expression));
exports.SameOrAfter = SameOrAfter;
var SameOrBefore = /** @class */ (function (_super) {
    __extends(SameOrBefore, _super);
    function SameOrBefore(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    SameOrBefore.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, d1, d2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        _a = _b.sent(), d1 = _a[0], d2 = _a[1];
                        if (d1 != null && d2 != null) {
                            return [2 /*return*/, d1.sameOrBefore(d2, this.precision != null ? this.precision.toLowerCase() : undefined)];
                        }
                        else {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return SameOrBefore;
}(expression_1.Expression));
exports.SameOrBefore = SameOrBefore;
// Implemented for DateTime, Date, and Time but not for Decimal yet
var Precision = /** @class */ (function (_super) {
    __extends(Precision, _super);
    function Precision(json) {
        return _super.call(this, json) || this;
    }
    Precision.prototype.exec = function (ctx) {
        return __awaiter(this, void 0, void 0, function () {
            var arg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.execArgs(ctx)];
                    case 1:
                        arg = _a.sent();
                        if (arg == null) {
                            return [2 /*return*/, null];
                        }
                        // Since we can't extend UnimplementedExpression directly for this overloaded function,
                        // we have to copy the error to throw here if we are not using the correct type
                        if (!arg.getPrecisionValue) {
                            throw new Error("Unimplemented Expression: Precision");
                        }
                        return [2 /*return*/, arg.getPrecisionValue()];
                }
            });
        });
    };
    return Precision;
}(expression_1.Expression));
exports.Precision = Precision;
//# sourceMappingURL=overloaded.js.map